import BlogLinkAction from 'client/components/core/Sidebar/components/Settings/components/BlogLink'
import { SettingsProps } from 'client/components/core/Sidebar/components/Settings/entities'
import { useUpdateProp } from 'client/components/core/Sidebar/components/Settings/hooks/useUpdateProps'
import { ButtonActionTypeEnum } from 'common/enums/ButtonActionTypeEnum'
import React from 'react'
import { usePreserveEntityFieldsAcrossDiscriminator } from 'src/editor/hooks/use-preserve-fields-across-discriminator/use-preserve-entity-fields-across-discriminator'
import { ActionButtonEntityInterface } from 'src/shared/entities/button/action-button.schema'
import { BlogLinkActionButtonEntityInterface } from 'src/shared/entities/button/blog-link.action-button.schema'
import { ButtonLinkActionSettingsLayout } from './button-link-action-settings-layout'

export const ButtonBlogLinkActionSettings = ({
  entity,
}: SettingsProps<ActionButtonEntityInterface>) => {
  const updateProp = useUpdateProp(
    entity as BlogLinkActionButtonEntityInterface,
  )

  usePreserveEntityFieldsAcrossDiscriminator({
    entity: entity as BlogLinkActionButtonEntityInterface,
    discriminator: [{ key: 'action', value: ButtonActionTypeEnum.BlogLink }],
    preservedKeys: ['blogLink', 'linkTarget', 'rel'],
  })

  return entity.action === ButtonActionTypeEnum.BlogLink ? (
    <ButtonLinkActionSettingsLayout entity={entity}>
      <BlogLinkAction
        update={updateProp('blogLink')}
        blogLink={entity.blogLink}
        needOptionWrapper
      />
    </ButtonLinkActionSettingsLayout>
  ) : null
}
